import { useMemo } from 'react'
import FormParams from '~/src/types/forms/FormParams'
import { GuestFormInterface } from '~/src/types/forms/GuestFormInterface'
import * as yup from 'yup'
import { useTranslations } from '~/src/hooks/useTranslations'
import { useEoValue } from '~/src/hooks/useEoState'
import { AUTHENTICATION_STATE } from '~/src/stores/authentication'
import useGuestFormFields from '~/src/hooks/forms/guest-form/useGuestFormFields'

const useGuestForm = (): FormParams<GuestFormInterface> => {
  const authState = useEoValue(AUTHENTICATION_STATE)
  const { getFieldRequiredValidator, getPhoneFieldValidator } = useGuestFormFields()
  const { t } = useTranslations()

  const initialValues = {
    email: authState?.guest?.email || '',
    firstName: authState?.guest?.firstName || '',
    lastName: authState?.guest?.lastName || '',
    phone: authState?.guest?.phone || '',
    society: authState?.guest?.society || ''
  }

  const validationSchema = useMemo(() => {
    return yup.object({
      email: getFieldRequiredValidator('email', {
        baseSchema: yup
          .string()
          .email(t('errors.email_invalid')),
        requiredMessage: t('errors.email_required')
      }),
      firstName: getFieldRequiredValidator('first_name', {
        baseSchema: yup.string(),
        requiredMessage: t('errors.firstName_required')
      }),
      lastName: getFieldRequiredValidator('last_name', {
        baseSchema: yup.string(),
        requiredMessage: t('errors.lastName_required')
      }),
      phone: getPhoneFieldValidator('phone', {
        baseSchema: yup.string(),
        requiredMessage: t('errors.phone_required'),
        invalidFormatMessage: t('errors.phone_wrong_format')
      }),
      society: getFieldRequiredValidator('company', {
        baseSchema: yup.string(),
        requiredMessage: t('errors.company_required')
      })
    })
  }, [ getFieldRequiredValidator, getPhoneFieldValidator ])

  return { initialValues, validationSchema }
}

export default useGuestForm
